import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Layout from "@/components/Layout";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
    const { t } = useLang();
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const from = location.state?.from?.pathname || "/";

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success(t("login") + " ✓");
            navigate(from, { replace: true });
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail) || err.message);
        } finally {
            setLoading(false);
        }
    };



    return (
        <Layout>
            <div className="max-w-md mx-auto px-4 py-16">
                <div className="bg-white border border-border rounded-3xl p-8 md:p-10 shadow-sm">
                    <h1 className="text-3xl font-black text-espresso">{t("login")}</h1>
                    <p className="text-sm text-muted-foreground mt-2">
                        {t("appName")}
                    </p>

                    

                    

                    <form onSubmit={onSubmit} className="space-y-4 mt-8" data-testid="login-form">
                        <div>
                            <Label htmlFor="email">{t("emailPlaceholder")}</Label>
                            <Input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                data-testid="email-input"
                                className="mt-1.5"
                            />
                        </div>
                        <div>
                            <Label htmlFor="password">{t("passwordPlaceholder")}</Label>
                            <Input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                data-testid="password-input"
                                className="mt-1.5"
                            />
                        </div>
                        <Button
                            type="submit"
                            disabled={loading}
                            className="w-full rounded-full h-11 bg-terracotta hover:bg-terracotta/90 text-white font-bold"
                            data-testid="login-submit-btn"
                        >
                            {loading ? "..." : t("login")}
                        </Button>
                    </form>

                    <div className="text-center text-sm text-muted-foreground mt-6">
                        <Link to="/register" className="text-terracotta font-bold hover:underline" data-testid="go-to-register-link">
                            {t("register")}
                        </Link>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
